import { Fragment } from "react";
import usePage from "../hooks/usePage";
import Menu from "../modules/public/menu/menu";
import Footer from "../modules/public/footer/footer";
import { Card, Collapse, Container } from "react-bootstrap";
import IncreaseCredit from "../modules/pages/myAccount/account/increaseCredit";
import TransactionTablePage from "../modules/pages/myAccount/account/transactionTableList";

const WalletPage = () => {
  const { pageSliders, pageImage, pageText } = usePage();

  return (
    <Fragment>
      <Menu />

      <main className="flex-grow-1">
        {pageSliders}
        {pageText}

        <Container className="rtl-all">
          <Collapse in={true}>
            <div id="example-collapse-text">
              <IncreaseCredit />

              <Card className="p-3 mt-4">
                <TransactionTablePage />
              </Card>
            </div>
          </Collapse>
        </Container>

        {pageImage}
      </main>

      <Footer />
    </Fragment>
  );
};

export default WalletPage;
